import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { YodaBorderRadius, YodaColors, YodaSpacing } from 'yoda-ui/yodaTheme';

export const TacticKanbanStyle: SxProps<Theme> = () => ({
  marginTop: YodaSpacing.medium,
  paddingBottom: YodaSpacing.medium,
  display: 'flex',
  flexDirection: 'column',
  gap: YodaSpacing.small,

  '& > *': {
    minWidth: '260px',
  },
});

export const TacticCardWrapperStyle: SxProps<Theme> = () => ({
  padding: YodaSpacing.medium,
  boxShadow: `0px 5px 20px ${YodaColors.gray2}`,
  borderRadius: YodaBorderRadius.medium,
});

export const TacticCardListStyle: SxProps<Theme> = {
  '& > *': {
    border: `1px solid ${YodaColors.gray7} !important`,
    borderRadius: YodaBorderRadius.small,
    marginBottom: YodaSpacing.small,
  },
  '& > *:last-child': {
    marginBottom: 0,
  },
};
